/**
 * Active MessageOrigin values for Reports filters (Order 31H).
 * Future producers stay in the domain enum but are hidden from filter UX
 * (not shown as disabled “coming soon”) so they do not look product-ready.
 */
import type { MessageOriginName } from "@multi-chat/shared";

export const REPORT_ACTIVE_ORIGINS = [
  "INBOX",
  "CAMPAIGN",
  "CAMPAIGN_SEND_TEST",
  "SYSTEM",
  "MOBILE_APP",
] as const satisfies readonly MessageOriginName[];

const ACTIVE = new Set<string>(REPORT_ACTIVE_ORIGINS);

export function isActiveReportOrigin(origin: string): origin is MessageOriginName {
  return ACTIVE.has(origin);
}

export function filterActiveReportOrigins(
  origins: readonly MessageOriginName[],
): MessageOriginName[] {
  return origins.filter(isActiveReportOrigin);
}
